export default "__VITE_PUBLIC_ASSET__47fbdc8f__"